import React from 'react';

import Button from './Button';

class ConfirmButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmShown: false
    };
  }

  handleClick = e => {
    const { confirmShown } = this.state;
    if (confirmShown) {
      this.props.onClick(e);
    } else {
      this.setState({ confirmShown: true });
    }
  };

  render() {
    const { confirmShown } = this.state;
    const { confirmLabel, onClick, label, ...props } = this.props;

    const lbl = confirmShown ? confirmLabel || 'Confirm action' : label;

    return <Button onClick={this.handleClick} label={lbl} {...props} />;
  }
}

export default ConfirmButton;



// WEBPACK FOOTER //
// ./src/components/basic/ConfirmButton.js